import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "./UserContext";
import { ROUTES } from "../constants/routes";

const RouteContext = createContext({});

export const RouteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, loading, isUserChecked, isActive } = useUser();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (loading || !isUserChecked) return;
    
        const isAuthPage = [
            ROUTES.LOGIN,
            ROUTES.REGISTER,
            ROUTES.RESET_REQUEST,
            ROUTES.RESET_PASSWORD,
            ROUTES.CONFIRM_EMAIL,
            ROUTES.VERIFY_PHONE,
            ROUTES.EMAIL_REDIRECT,
            ROUTES.PROFILE_SETUP
        ].includes(location.pathname as ROUTES);
    
        if (isAuthPage && user && isActive ) {
            navigate(ROUTES.DASHBOARD, { replace: true });
        }
    }, [user, loading, isUserChecked, location.pathname, navigate]);

    return <RouteContext.Provider value={{}}>{children}</RouteContext.Provider>;
};

export const useRoute = () => {
    return useContext(RouteContext);
};